import { CheckOutlined, CopyOutlined, QrcodeOutlined } from "@payping/icons";
import { addOverflow, safeJoinPath } from "@payping/utils/string";
import { Card, PopoverImage, Typography } from "@payping/web-components";
import { prefixCls } from "@payping/web-components/style/variables";
import classNames from "classnames";
import QRCode from "qrcode.react";
import React, { useEffect, useState } from "react";

import { webConstants } from "@payping/utils/platformConstants";
import { useAppSelector } from "@/utils/redux";
import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "@/assets/scss/Overview.module.scss";
import { downloadPersonalPageQrId, personalPageCopyId, personalPageLinkId } from "@/assets/googleTrackIds";

const PersonalPage: React.FC = () => {
  const { t } = useAppTranslation();
  const username = useAppSelector((state) => state.user.personalInfo?.username);

  const url = safeJoinPath(`https://${webConstants.MAIN_HOST}`, `@${username}`);
  const qrDownloadUrl = "personal-page-qr";
  const [qrDataUrl, setQrDataUrl] = useState<string>();
  const [limit, setLimit] = useState<number>(10);
  const ref = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateUsernameWidth = () => {
      const width = ref.current?.parentElement?.parentElement?.clientWidth || 0;
      setLimit((width - 160) / 10);
    };
    window.addEventListener("resize", updateUsernameWidth);
    return () => window.removeEventListener("resize", updateUsernameWidth);
  }, [ref]);

  return (
    <Card.Raw className={styles.personalCard}>
      <Card.Raw.RowMeta title={t("overview.personalPage.title")}>
        {username ? (
          <div className={styles.personalTypography} ref={ref}>
            <QRCode
              id={qrDownloadUrl}
              // this component is hidden from user, and is used for downloading a qr bigger than what user sees in dashboard
              style={{ display: "none" }}
              size={400}
              includeMargin={true}
              value={url}
            />
            <PopoverImage
              imageComponent={<QRCode size={80} includeMargin={true} value={url} />}
              onClick={() => {
                const canvas = document.getElementById(qrDownloadUrl) as HTMLCanvasElement;
                setQrDataUrl(canvas.toDataURL());
              }}
              label={
                <a
                  id={"qr-anchor"}
                  download={"PayPing-QR"}
                  href={qrDataUrl}
                  data-google-track={downloadPersonalPageQrId}
                >
                  {t("common.download")}
                </a>
              }
            >
              <div>
                <QrcodeOutlined className={classNames(`${prefixCls}-icon`, "color--cta")} width={"20px"} />
              </div>
            </PopoverImage>
            <a href={url} target={"_blank"} rel={"noreferrer"} data-google-track={personalPageLinkId}>
              <Typography.Text
                className={styles.personalLink}
                copyable={{
                  icon: [
                    <CopyOutlined key={0} width={"20px"} height={"20px"} data-google-track={personalPageCopyId} />,
                    <CheckOutlined key={1} width={"16px"} height={"16px"} />,
                  ],
                  text: url,
                }}
              >
                {addOverflow(`@${username}`, limit)}
              </Typography.Text>
            </a>
          </div>
        ) : (
          <Typography>{"-"}</Typography>
        )}
      </Card.Raw.RowMeta>
    </Card.Raw>
  );
};

export default PersonalPage;
